/**
 * Unified content channels across the application
 * Single source of truth for Write, Chat, Repurpose, and Discovery
 */
export const CONTENT_CHANNELS = [
  // Social Platforms
  { value: "linkedin", label: "LinkedIn" },
  { value: "twitter", label: "Twitter/X" },
  // Written Content
  { value: "blog_post", label: "Blog Post" },
  { value: "newsletter", label: "Newsletter" },
  { value: "email", label: "Email" },
  { value: "website", label: "Website Copy" },
  { value: "seo_article", label: "SEO Article" },
  { value: "video_script", label: "Video Script" },
  // Custom
  { value: "custom", label: "Custom" },
] as const;

export type ContentChannel = typeof CONTENT_CHANNELS[number]['value'];

/** @deprecated Use CONTENT_CHANNELS instead */
export const PLATFORM_CHANNELS = CONTENT_CHANNELS;

/**
 * Common purposes for content creation
 */
export const CONTENT_PURPOSES = [
  { value: "educate", label: "Educate" },
  { value: "inspire", label: "Inspire" },
  { value: "persuade", label: "Persuade" },
  { value: "entertain", label: "Entertain" },
  { value: "inform", label: "Inform" },
  { value: "sell", label: "Sell" },
] as const;

export type ContentPurpose = typeof CONTENT_PURPOSES[number]['value'];

/**
 * Common target audiences
 */
export const TARGET_AUDIENCES = [
  { value: "professionals", label: "Professionals" },
  { value: "executives", label: "Executives & Leaders" },
  { value: "entrepreneurs", label: "Entrepreneurs" },
  { value: "marketers", label: "Marketers" },
  { value: "developers", label: "Developers & Tech" },
  { value: "creatives", label: "Creatives & Designers" },
  { value: "students", label: "Students" },
  { value: "general", label: "General Audience" },
] as const;

export type TargetAudience = typeof TARGET_AUDIENCES[number]['value'];
